const React = require("react");
const { Routes, Route, Navigate } = require("react-router-dom");
const { InventorySourceProvider } = require("./context/InventorySourceContext");
const { InventorySourceLayout } = require("./components/InventorySourceLayout");
const { DropshippingPlatforms } = require("./pages/DropshippingPlatforms");
const { DropshippingPlatformDetails } = require("./pages/DropshippingPlatformDetails");
const { DropshippingInventorySourceConnect } = require("./pages/DropshippingInventorySourceConnect");
const { DropshippingSuppliers } = require("./pages/DropshippingSuppliers");
const { DropshippingSupplierProducts } = require("./pages/DropshippingSupplierProducts");
const { DropshippingAllProducts } = require("./pages/DropshippingAllProducts");
const { DropshippingProductDetails } = require("./pages/DropshippingProductDetails");
const { DropshippingImportedProducts } = require("./pages/DropshippingImportedProducts");
const { DropshippingOrders } = require("./pages/DropshippingOrders");
const { DropshippingApiErrors } = require("./pages/DropshippingApiErrors");
const { DropshippingAdmin } = require("./pages/DropshippingAdmin");
const { AdminInventorySourceConnections } = require("./pages/AdminInventorySourceConnections");
const { AdminInventorySourceSuppliers } = require("./pages/AdminInventorySourceSuppliers");
const { AdminInventorySourceProducts } = require("./pages/AdminInventorySourceProducts");
const { AdminInventorySourceLogs } = require("./pages/AdminInventorySourceLogs");
const { AdminInventorySourceOrders } = require("./pages/AdminInventorySourceOrders");
const h = React.createElement;

const InventorySourceRoutes = () => h(Routes, null,
  h(Route, { element: h(InventorySourceLayout) },
    h(Route, { path: "inventory-source", element: h(DropshippingPlatforms) }),
    h(Route, { path: "inventory-source/details", element: h(DropshippingPlatformDetails) }),
    h(Route, { path: "inventory-source/connect", element: h(DropshippingInventorySourceConnect) }),
    h(Route, { path: "inventory-source/connected", element: h(DropshippingInventorySourceConnect) }),
    h(Route, { path: "inventory-source/suppliers", element: h(DropshippingSuppliers) }),
    h(Route, { path: "inventory-source/suppliers/:supplierId/products", element: h(DropshippingSupplierProducts) }),
    h(Route, { path: "inventory-source/products", element: h(DropshippingAllProducts) }),
    h(Route, { path: "inventory-source/products/:productId", element: h(DropshippingProductDetails) }),
    h(Route, { path: "inventory-source/imported", element: h(DropshippingImportedProducts) }),
    h(Route, { path: "inventory-source/orders", element: h(DropshippingOrders) }),
    h(Route, { path: "inventory-source/errors", element: h(DropshippingApiErrors) }),
    h(Route, { path: "inventory-source/admin", element: h(DropshippingAdmin) }),
    h(Route, { path: "inventory-source/admin/connections", element: h(AdminInventorySourceConnections) }),
    h(Route, { path: "inventory-source/admin/suppliers", element: h(AdminInventorySourceSuppliers) }),
    h(Route, { path: "inventory-source/admin/products", element: h(AdminInventorySourceProducts) }),
    h(Route, { path: "inventory-source/admin/logs", element: h(AdminInventorySourceLogs) }),
    h(Route, { path: "inventory-source/admin/orders", element: h(AdminInventorySourceOrders) }),
    h(Route, { path: "inventory-source/*", element: h(Navigate, { to: "/dropshipping/inventory-source", replace: true }) })
  )
);

const InventorySourceApp = ({ baseUrl, token, translate, roleName }) => h(InventorySourceProvider, { baseUrl, token, translate, roleName }, h(InventorySourceRoutes));
module.exports = { InventorySourceApp, InventorySourceRoutes };
